export default from './BidMessage';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/BidMessage/index.js